import {required } from "@vuelidate/validators";
const obirim = {
    data() {
      return { 
        obirimData:{
          Birimkodu:null,
          Birimadi:null,
          Temsilci:null,
          Telefon:null,
          Eposta:null, 
          Adres:null, 
          Ustbirimid: null,
          Amirids: [],
          Uygulamaids: [],
        },  
          FormDataType:{
            Birimkodu:{FieldName:"Birimkodu",Field:"input",FieldTitle:"Birim Kodu"},
            Birimadi:{FieldName:"Birimadi",Field:"input",FieldTitle:"Birim Adı"},
            Temsilci:{FieldName:"Temsilci",Field:"input",FieldTitle:"Temsilci"},
            Telefon:{FieldName:"Telefon",Field:"input",FieldTitle:"Telefon"},
            Eposta:{FieldName:"Eposta",Field:"input",FieldTitle:"E-Posta"},
            Adres:{FieldName:"Adres",Field:"input",FieldTitle:"Adres"}, 
            Ustbirimid:{FieldName:"Ustbirimid",Field:"combobox",FieldTitle:"Üst Birim",ComboData:{},ComboDataArray:[],Multiple:false}, 
            Amirids:{FieldName:"Amirids",Field:"combobox",FieldTitle:"Amirler",ComboData:{},ComboDataArray:[],Multiple:true}, 
            Uygulamaids:{FieldName:"Uygulamaids",Field:"combobox",FieldTitle:"Uygulamalar",ComboData:{},ComboDataArray:[],Multiple:true}, 
          }   

            

      }  
    }, 
    validations:{ 
      FormData: {
        Birimkodu: { required },
        Birimadi: { required },
        Temsilci: {  },
        Telefon: {  },
        Eposta: {  },  
        Adres: {  },  
        Ustbirimid: {  },  
        Amirids: {  }, 
        Uygulamaids: {  },
      } 
  },
  created(){ 
 

    this.ActionsFilterGet({ Service: "obirim/gettree", FullData: true, Filter: "" }).then((res) => {
      this.FormDataType.Ustbirimid.ComboDataArray = res.Data 
    });
  
this.ActionsFilterGet({ Service: "opersonel", FullData: true, Filter: "&Birimtip=" })
  .then((res) => {
    this.FormDataType.Amirids.ComboDataArray = res.Data
      .filter(x => x && x.Id)
      .map(item => ({
        id: String(item.Id),
        label: item.Adsoyad || ""
      }));
  });
   
    this.ActionsFilterGet({ Service: "okeyvalues", FullData: true, Filter: "&Asc=Kod&Tip=8" }).then((res) => {
      this.FormDataType.Uygulamaids.ComboDataArray = res.Data.map(item => ({
        id: item.Id,
        label: item.Value
      }));
    });





  }
}
export default obirim